
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 16 16","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M7.333 2.667a4.667 4.667 0 100 9.334 4.667 4.667 0 000-9.334zm-6 4.667a6 6 0 1112 0 6 6 0 01-12 0z"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M10.629 10.629c.26-.26.682-.26.942 0l2.9 2.9a.667.667 0 11-.942.943l-2.9-2.9a.667.667 0 010-.943z"}})])
          )
        }
      }
    